<template><div><h1>VUX V2.5.4 released</h1>
<h2><a href="/en/components/group.html">Group</a></h2>
<ul><li>[enhance] XSwitch：labelAlign support justify #1707</li>
</ul>
<h2><a href="/en/components/sticky.html">Sticky</a></h2>
<ul><li>[fix] Auto re-bind after router-view transition is finished</li>
<li>[fix] Fix position fixed not work in ios #1657</li>
</ul>
<h2><a href="/en/components/tabbar.html">Tabbar</a></h2>
<ul><li>[feature] Add event:on-index-change #1715</li>
</ul>
<h2><a href="/en/components/x-img.html">XImg</a></h2>
<ul><li>[feature] re-init after router-view transition is finished</li>
</ul>
<h2><a href="/en/components/bus.html">Bus</a></h2>
<ul><li>[feature] new plugin for managing events</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.5.4 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.5.4-125.vue?fa98a49a